import { ComponentStyles } from "types/common";

export const styles: ComponentStyles = {
  container: {
    py: 3,
  },
  paper: {
    p: 2,
    mb: 4,
    // backgroundColor: "rgba(255, 255, 255, 0.02)",
    borderRadius: 3,
    // border: "1px solid rgba(255, 255, 255, 0.05)",
    boxShadow: "none",
  },
  versionDisplay: {
    p: 2,
    px: 3,
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    borderRadius: 3,
    color: "text.primary",
    fontSize: "1.25rem",
    fontWeight: 600,
    display: "inline-block",
  },
  textField: {
    mb: 2,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "rgba(255, 255, 255, 0.05)",
      borderRadius: 10,
      "& fieldset": {
        border: "none",
      },
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.08)",
      },
    },
    "& .MuiInputLabel-root": {
      color: "text.secondary",
    },
  },
  warning: {
    mt: 2,
    mb: 2,
    backgroundColor: "rgba(255, 152, 0, 0.1)",
    color: "rgba(255, 152, 0, 0.9)",
    borderRadius: 2,
    "& .MuiAlert-icon": {
      color: "rgba(255, 152, 0, 0.9)",
    },
  },
  button: {
    borderRadius: 10,
    textTransform: "none",
    fontWeight: 600,
    px: 3,
    mt: 1,
  },
};
